import type { Cart } from '../../domain/Cart';
import type { CartRepository } from '../../domain/CartRepository';

const getCart = (repository: CartRepository): Promise<Cart | null> => {
  return repository.get();
};

export default getCart;
